import { ActionIcon, Badge, Button, Group, Indicator, Popover, ScrollArea, Stack, Text, UnstyledButton } from "@mantine/core"
import { IconBell } from "@tabler/icons-react"
import moment from "moment"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { NotificacionRendicion, useGetNotificaciones, useMarcarNotificacionesLeidas } from "../hooks/rendicion-queries"

const PARA_REVISION = ["ENVIADA", "REENVIADA"]

export default function NotificacionesBell() {
  const navigate = useNavigate()
  const [abierto, setAbierto] = useState(false)
  const participa = true
  const { data } = useGetNotificaciones(participa)
  const marcar = useMarcarNotificacionesLeidas()

  if (!participa) return null

  const noLeidas = data?.noLeidas ?? 0
  const abrir = (n: NotificacionRendicion) => {
    if (!n.leida) marcar.mutate([n._id])
    setAbierto(false)
    navigate(PARA_REVISION.includes(n.evento) ? `/rendiciones/${n.rendicionId}/revision` : `/rendiciones/${n.rendicionId}`)
  }

  return (
    <Popover opened={abierto} onChange={setAbierto} width="min(380px, 92vw)" position="bottom-end" shadow="md" withinPortal>
      <Popover.Target>
        <Indicator label={noLeidas > 9 ? "9+" : noLeidas} disabled={noLeidas === 0} size={16} color="red" offset={4}>
          <ActionIcon variant="subtle" size="lg" aria-label={`Notificaciones${noLeidas ? ` (${noLeidas} sin leer)` : ""}`} onClick={() => setAbierto((v) => !v)}>
            <IconBell size={20} />
          </ActionIcon>
        </Indicator>
      </Popover.Target>
      <Popover.Dropdown p={0}>
        <Group justify="space-between" p="sm" style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
          <Text fw={700}>Notificaciones de rendiciones</Text>
          <Button size="compact-xs" variant="subtle" disabled={noLeidas === 0} onClick={() => marcar.mutate(undefined)}>Marcar todas como leídas</Button>
        </Group>
        <ScrollArea.Autosize mah={420}>
          {(data?.data ?? []).length === 0 && <Text ta="center" c="dimmed" size="sm" py="lg">Sin notificaciones</Text>}
          {(data?.data ?? []).map((n) => (
            <UnstyledButton key={n._id} onClick={() => abrir(n)} w="100%" p="sm" style={{ borderBottom: "1px solid var(--mantine-color-gray-2)", background: n.leida ? undefined : "var(--mantine-color-green-0)" }}>
              <Stack gap={2}>
                <Group justify="space-between" wrap="nowrap" align="flex-start">
                  <Text size="sm" fw={n.leida ? 500 : 700}>{n.asunto}</Text>
                  {!n.leida && <Badge size="xs" color="green" variant="filled">Nueva</Badge>}
                </Group>
                <Text size="xs" c="dimmed">{n.mensaje}</Text>
                {n.detalle?.slice(0, 3).map((d) => <Text key={d} size="xs">• {d}</Text>)}
                {(n.detalle?.length ?? 0) > 3 && <Text size="xs" c="dimmed">y {n.detalle.length - 3} más…</Text>}
                <Text size="xs" c="dimmed">{moment(n.createdAt).fromNow()}</Text>
              </Stack>
            </UnstyledButton>
          ))}
        </ScrollArea.Autosize>
      </Popover.Dropdown>
    </Popover>
  )
}
